import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public uiBasicCollapsed = false;
  public designCollapsed = false;
  public salesCollapsed = false;
  public ordersCollapsed = false;
  public customersCollapsed = false;
  public marketingCollapsed = false;
  public feedbackCollapsed = false;
  public analyticsCollapsed = false;
  public reportsCollapsed = false;
  public samplePagesCollapsed = false;
  public deliveryCollapsed = false;
  public userName: string = '';
  public role: string = '';

  setActiveFlag: string;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        if (event.url) {
          this.setActiveFlag = this.setActive(event.url);
        }
      }
    });
  }

  setActive(e) {
    switch (true) {
      case e.includes('dashboard'):
        return 'dashboard'
      case e.includes('orders'):
        return 'orders'
      case e.includes('catlog'):
        return 'catlog'
      case e.includes('design'):
        return 'design'
      case e.includes('customers'):
        return 'customers'
      case e.includes('delivery'):
        return 'delivery'
      case e.includes('feedback'):
        return 'feedback'
      case e.includes('marketing'):
        return 'marketing'
      case e.includes('sales'):
        return 'sales'
      case e.includes('analytics'):
        return 'analytics'
      default:
        return 'dashboard'
    }
  }

  ngOnInit() {
    const body = document.querySelector('body');
    this.userName = this.authenticationService.currentUser.username;
    this.role = this.authenticationService.currentUser.role;
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}
